import React from 'react'
import { Context } from '../../context'
import Pc from './pc/Index'
import Mobile from './mobile/Index'

export default function() {
  React.useEffect(() => {
    const dom = document.getElementById('info-observe-id')
    // @ts-ignore
    const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver

    const mutationObserver = new MutationObserver(() => {
      const height = window?.document.getElementById("root")?.clientHeight
      // console.log('height--:', height);
      window.parent.postMessage({
        height,
        type: "height",
      }, "*");

      // setTimeout(() => {}, 0)
    })

    // @ts-ignore
    mutationObserver.observe(dom, {
      childList: true, // 子节点的变动（新增、删除或者更改）
      attributes: true, // 属性的变动
      characterData: true, // 节点内容或节点文本的变动
      subtree: true, // 是否将观察器应用于该节点的所有后代节点
      attributeFilter: ['style'], // 观察特定属性
      attributeOldValue: true, // 观察 attributes 变动时，是否需要记录变动前的属性值
      characterDataOldValue: true // 观察 characterData 变动，是否需要记录变动前的值
    })

    return () => {
      if (mutationObserver) {
        mutationObserver.disconnect() // 此处以后的不再监听
      }
    }
  }, [])

  React.useEffect(() => {
    const postMessage:any = ()=> {
      const height = window?.document.getElementById("root")?.clientHeight
      window.parent.postMessage({
        height,
        type: "height",
      }, "*");
    }

    window.addEventListener('message', postMessage)
    return () => {
      window.removeEventListener('message', postMessage)
    }
  }, [])

  return (
    <Context.Consumer>
      {value => value === 'pc' ? <Pc/>: <Mobile/>}
    </Context.Consumer>
  )
}
